import { array, mixed, number, object, string } from "yup";

export const AddPlanSchema = object({
  selectedStudent: object().shape({
    label: string(),
    value: string(),
  }).required("Debes seleccionar un alumno"),
  selectedPlanId: string().required("Debes seleccionar un plan"),
  selectedPlans: array()
    .of(
      object().shape({
        id: string(),
        defaultLessonId: string(),
        name: string(),
        lessons: mixed(),
        pricingIndex: number(),
        locationId: string().required("Debes seleccionar una sucursal"),
      })
    )
    .min(1, "Debes seleccionar por lo menos un plan"),
  noReference: string().required("Debes agregar la cuenta"),
  paymentMethod: string(),
});
